import styled from 'styled-components';

export const LeftPage = styled.div`
  width: 6rem;
  height: auto;
  padding: 0.2rem;
  padding-bottom: 0px;
`;

export const LeftTopBox = styled.div`
  flex: 2;
  position: relative;
  //height: 4.375rem;
  height: 2.6rem;
  width: 100%;
  .left-top-borderBox12 {
    width: inherit;
    height: inherit;
    padding: 0.1875rem;
    .left-top {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background-color: rgba(19, 25, 47, 0.6);
      .title-dis {
        margin-top: 0.1875rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 0.2rem;
        color: #c0c9d2;
        &-keyword {
          padding-left: 0.125rem;
          color: #47dae8;
        }
      }
      :root {
          color-scheme: light only;  /* 声明这是浅色主题，浏览器不要改 */
      }
      .detail-list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: space-between;
        justify-content: space-around;
        width: 100%;
        margin-top:0.15rem;
        &-item {
          display: flex;
          align-items: center;
          position: relative;
          height: 1.5625rem;
          padding: 0 0.125rem;
          width: 32%;
          border-radius: 5px;
          border: 1px solid #343f4b;
          background-color: rgba(19, 25, 47, 0.8);
          justify-content: center;
          img {
            width: 1.25rem;
            height: 1.25rem;
          }
          .detail-item-text {

            h3 {
              color: #bcdcff;
              font-size: 16px;
              margin-bottom: 0.25rem;
              text-align:center;
            }
            span {
              font-weight: 500px;
              font-size: 0.25rem;
              font-weight: bolder;
              //background: linear-gradient(to bottom, #fff, #4db6e5);
              background: #4db6e5;
              color: transparent;
              -webkit-background-clip: text;
              background-clip: text;
            }
            .unit {
              font-size: 0.2rem;
              margin-left: 0.125rem;
            }
          }
        }
      }

    }
  }
`;
var screenHeight = window.screen.height;
var fontSize1 = '15';
var fontSize2 = '18';
if(screenHeight < 900){
  fontSize1 = '11';
  fontSize2 = '13';
}
export const LeftBottomBox = styled.div`
  position: relative;
  margin-top: 0.25rem;
  flex: 6; /* 底部占5份 */
  //height: 5.9rem;
  height: 7.7rem;
  //height: calc(59vh); /* 占视口高度的25%，可根据实际调整 */
  ///* 高宽比小于16:9（竖屏或宽屏但高度不足）时减小高度 */
  //@media (max-aspect-ratio: 16/9) {
  //  height: 5.9rem;
  //}
  //
  ///* 高宽比大于21:9（超宽屏）时增加高度 */
  //@media (min-aspect-ratio: 21/9) {
  //  height: 8rem;
  //}
  //height: clamp(5.9rem, 7rem, 8rem);
  ///* 根据屏幕宽度设置不同的高度 */
  //@media (max-width: 1280px) {
  //  height: 3.5rem; /* 小屏幕高度 */
  //}
  //
  //@media (min-width: 1281px) and (max-width: 1920px) {
  //  height: 5.9rem; /* 中等屏幕高度（默认） */
  //}
  //
  //@media (min-width: 1921px) {
  //  height: 5rem; /* 大屏幕高度 */
  //}
  width: 100%;
  .left-bottom-borderBox13 {
    width: inherit;
    height: inherit;
    padding: 0.25rem 0.1875rem;
    .left-bottom {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background-color: rgba(19, 25, 47, 0.6);
    }
  }
.dv-scroll-board .row-item {
  font-size: ${fontSize1}px;
}
.dv-scroll-board .header-item {
  font-size: ${fontSize2}px;
}
`;
